
import Vue from "vue";
import { PropType } from "vue";
import { tapestryMixins } from "@/mixins/tapestryMixins";
import { TapestryPlay } from "@/types";

export default Vue.extend({
  name: "TapestryScoresPlay",
  mixins: [tapestryMixins],
  props: {
    play: {
      type: Object as PropType<TapestryPlay>,
      required: true,
    },
    mainPlayerId: {
      type: Number,
      default: 1,
    },
  },
});
